import React, { Component } from 'react';
import './Deals.css';
import {DealItem} from './DealItem'
import SimpleSlider from '../SimpleSlider/SimpleSlider';
import { Img } from '../UI/UI.js-p1';
import { getImgUrl , limitText } from "../../Utility/Utility"


class Deals extends Component {
  
  constructor (props){
  	super(props);
  	this.image_url = getImgUrl();
  	
  	this.dealsSliderSettings = {
      	dots: true,
      	infinite: true,
      	cssEase: 'linear',
      	autoplay:false,
      	lazyLoad: "ondemand",
      	slidesToShow: (this.props.items != undefined  ) ? this.props.items : 3,
		slidesToScroll: 1,
		responsive: [
	        {
	          breakpoint: 1000,
	          settings: {
	            slidesToShow: 2,
	            slidesToScroll: 2
	          }
	        },
	        {
	          breakpoint: 600,
	          settings: {
	            slidesToShow: 1,
	            slidesToScroll: 1
	          }
	        }
      	]
    };

  	  	this.deals = [
			{
				price : "550 €",
				title : "Evaneos",
				desc : "City break Tel Aviv - 5J/4N",
				link:  "https://www.evaneos.fr/israel/itineraire/14253-city-break-tel-aviv-5-jours-4-nuits/",
				logo: "/Deals/Evaneos.jpg",
				book_now:"RÉSERVEZ MAINTENANT"
			},
			{
				price : "953 €",
				title : "Lidl voyages",
				desc : "AUTOKIBBOUTZ - 8J/7N LOC. DE VOITURE",
				link:  "https://www.lidl-voyages.fr/product.html?s_pid=231508#ref_dd=11&ref_dmy=06/2022&ref_aj=0&ref_minMan=7,7&ref_mmd=8,8&ref_dpci=LYS&s_c.PRODUCT_TYPE=CIRCUIT&s_c.DEST=ISR&fromSerp=1",
				logo: "/Deals/Lidlvoyages.jpg",
				book_now:"RÉSERVEZ MAINTENANT"
			},
			{
				price : "980 €",
				title : "Maison du Voyage",
				desc : "Jérusalem Autrement",
				link:  "https://www.maisonsduvoyage.com/orient/israel",
				logo: "/Deals/MaisonduVoyage.jpg",
				book_now:"RÉSERVEZ MAINTENANT"
			},
			{
				price : "1142 €",
				title : "Voyamar",
				desc : "L'ETOILE - ESCAPADE AUTOUR DE TEL AVIV - 8J/7N",
				link:  "https://www.voyamar-vacances.com/product.cms?s_pid=39938&s_c.de=IL.TLV&s_dmy=05/2022&s_dd=19&s_aj=2&s_dpci=GVA&s_c.type=circuits_autotours",
				logo: "/Deals/Voyamar.jpg",
				book_now:"RÉSERVEZ MAINTENANT"
			},
			{
				price : "1167 €",
				title : "Selectour",
				desc : "AUTOTOUR DES 4 MERS - 8J/7N",
				link:  "https://www.selectour.com/israel/circuit",
				logo: "/Deals/Selectour.jpg",
				book_now:"RÉSERVEZ MAINTENANT"
			},
			{
				price : "1500 €",
				title : "Voyageurs du Monde",
				desc : "Tel-Aviv solaire - Week-end énergique et (pluri) culturel",
				link:  "https://www.voyageursdumonde.fr/voyage-sur-mesure/idees-voyage/week-end-en-ville/israel-94",
				logo: "/Deals/VoyageursduMonde.jpg",
				book_now:"RÉSERVEZ MAINTENANT"
			},
			{
				price : "1590 €",
				title : "Salaün Holidays",
				desc : "Circuit découvertes en Israël - 8J/7N",
				link:  "https://www.salaun-holidays.com/recherche-circuit,israel-2-92-0-0.html",
				logo: "/Deals/SalaünHolidays.jpg",
				book_now:"RÉSERVEZ MAINTENANT"
			},
			{
				price : "1539 €",
				title : "VisitEurope",
				desc : "Circuit TRÉSOR HISTORIQUE ET CULTUREL",
				link:  "https://www.visiteurope.fr/circuit-israel/circuit-israel-israel-tresor-historique-et-culturel-14764.html#ref_dd=07&ref_dmy=05/2022&ref_aj=0&ref_minMan=7,7&ref_mmd=8,8&ref_dpci=BRU",
				logo: "/Deals/VisitEurope.jpg",
				book_now:"RÉSERVEZ MAINTENANT"
			},
			{
				price : "1869 €",
				title : "Nomade Aventure",
				desc : "Au cœur de l'Histoire et des Peuples",
				link:  "https://www.nomade-aventure.com/voyage-aventure/israel/voyage-palestine/pal04",
				logo: "/Deals/NomadeAventure.jpg",
				book_now:"RÉSERVEZ MAINTENANT"
			},
			{
				price : "2099 €",
				title : "Carrefour Voyages",
				desc : "Circuit Israël en liberté - 8J/7N",
				link:  "https://voyages.carrefour.fr/circuits/jerusalem/tel-aviv/circuit-israel-en-liberte?pageType=product&s_pid=337335#ref_dd=14&ref_dmy=11/2022&ref_aj=0&ref_minMan=7,7&ref_mmd=8,8&ref_dpci=PAR",
				logo: "/Deals/CarrefourVoyages.jpg",
				book_now:"RÉSERVEZ MAINTENANT"
			},
			{
				price : "2149 €",
				title : "Nouvelles Frontières",
				desc : "Circuit Terre d'Histoire - 8J/7N",
				link:  "https://www.tui.fr/circuit-terre-dhistoire_ISRCT002/?duration=7&departuredate=18092022&departurecitycode=PAR",
				logo: "/Deals/NouvellesFrontières.jpg",
				book_now:"RÉSERVEZ MAINTENANT"
			},
			{
				price : "2210 €",
				title : "Arts et Vie",
				desc : "Circuit de la Galilée à la mer Morte - 8J/7N",
				link:  "https://www.artsetvie.com/circuit/israel/circuit-en-israel-de-la-galilee-a-la-mer-morte-188.html",
				logo: "/Deals/ArtsetVie.jpg",
				book_now:"RÉSERVEZ MAINTENANT"
			},
			{
				price : "3190 €",
				title : "Club Med",
				desc : "Carrefour du temps",
				link:  "https://www.clubmed.fr/i/carrefour-du-temps/y",
				logo: "/Deals/ClubMed.jpg",
				book_now:"RÉSERVEZ MAINTENANT"
			}
		]

  }

  render() {

  	const dealsHtml = this.deals.map((o)=>{
  		return <DealItem 
		            key={o.title}
  					brand={ o.title } 
  					price={ o.price } 
  					brandImg={ o.logo } 
  					desc={ o.desc } 
  					bookNowLink={o.link}
  					descFontSize={ o.fontSize }
				/>
  	})
    return (
	      <div className="deals-wrapper">
        	<SimpleSlider settings={this.dealsSliderSettings}>
	           {dealsHtml}
          	</SimpleSlider>
	      </div>
    );
  }
}

export default Deals;



// WEBPACK FOOTER //
// ./src/Components/Deals/Deals.js